import { render } from "./Main-Forgotpw.vue?vue&type=template&id=36643d5c"
import script from "./Main-Forgotpw.vue?vue&type=script&lang=js"
export * from "./Main-Forgotpw.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__